import { useMemo } from 'react';
import useQuery from 'hooks/useQuery';
import { CollectionStats, CollectionStatsApiResponse } from '../types';
import { getCountryCurrency } from 'utils/helpers';

const formatCollectionStats = (
  data: CollectionStatsApiResponse,
  country: string,
): CollectionStats => {
  const res = {} as CollectionStats;

  const totalCash = data?.cashSummary?.find(
    (item) => item.status === 'RECEIVED',
  );
  const lateCash = data?.cashSummary?.find((item) => item.status === 'OVERDUE');

  res.totalCash = {
    amount: totalCash?.cashTotal ?? 0,
    // TODO : Add currency from api
    currency: totalCash?.currency || getCountryCurrency(country),
  };

  res.lateCash = {
    amount: lateCash?.cashTotal ?? 0,
    // TODO : Add currency from api
    currency: lateCash?.currency || getCountryCurrency(country),
  };

  res.lateAgronomist = lateCash?.noOfAgronomists || 0;

  return res;
};

const useCollectionStats = (country: string, seasonIndex: string) => {
  const options = useMemo(
    () => ({
      params: {
        'country.equals': country,
        'seasonTypeId.equals': seasonIndex,
        'paymentType.equals': 'cash',
        'status.equals': 'RECEIVED',
      },
    }),
    [country, seasonIndex],
  );
  const { data, error, isLoading } = useQuery<CollectionStats>(
    'collection/cash-summary',
    options,
    !!country && !!seasonIndex,
  );

  return {
    data: formatCollectionStats(
      data as unknown as CollectionStatsApiResponse,
      country,
    ),
    error,
    isLoading,
  };
};

export default useCollectionStats;
